<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"></loading>
    <b-card>
      <b-row align-v="center" slot="header">
        <b-col cols="1">
          <b-button size="md" @click="redirectToHome" variant="outline-primary"><i
              class="fa-solid fa-house-chimney"></i></b-button>
        </b-col>
        <b-col cols="4">
          <v-select ref="clientsDropdown" class="vue-select" placeholder="Choose a Client" :options="userClientOptions" label="name"
            v-model="client" :reduce="(option) => option.id" v-on:input="filterClaimListByClient"></v-select>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="3">
          <div class="form-group">
            <label class="form-control-label">Select Claim Document</label>
            <v-select ref="claimDropdown" class="vue-select" placeholder="Select Claim Document" :options="clientClaimOptions"
              v-model="claim" :reduce="(option) => option.id" v-on:input="changeClaimDocument"></v-select>
          </div>
        </b-col>
        <b-col lg="3">
          <div class="form-group">
            <label class="form-control-label">Claim Status: </label>
            <v-select ref="claimStatusesDropdown" v-if="activeClaim" :clearable="false" :options="claimStatuses" v-model="activeClaim.claimStatus"
              v-on:input="claimStatusChanged" label="name" :reduce="(option) => option.id"
              :selectable="item => !item.disabledByDefault || activeClaim.internalReviewStatus == 5"></v-select>
          </div>
        </b-col>

        <b-col lg="3">
          <div class="pt-4 mt-2">
            <b-button size="md" :class="dynamicClass" :disabled="!claim" @click="onclickPinClaim"
              variant="outline-primary"><i class="fa-solid fa-thumbtack"></i></b-button>
            <label class="form-control-label">Pin Claim</label>
          </div>
        </b-col>
      </b-row>

      <b-card no-body>
        <b-row>
          <b-col lg="12">
            <div class="float-right pt-4 mb--9 special-buttons pr-3 pb-3">
              <b-button :disabled="internalReviewDiableCheck" @click="setAcitveTabPane(5)" variant="outline-primary"
                class="btn-design" :class="tb_step == 5 ? 'active' : ''"><i class="fa-solid pr-2"
                  v-bind:class="internal_review_class"></i>
                Internal Review
              </b-button>
              <b-button @click="setAcitveTabPane(6)" variant="outline-primary" :disabled="disablePublishTabCondition"
                class="btn-design" :class="tb_step == 6 ? 'active' : ''"><i class="fa-solid fa-upload pr-2"></i>Publish
                Claim</b-button>
            </div>
          </b-col>
          <b-col lg="12">
            <b-tabs pills card v-model="tb_step">
              <b-tab title="Summary">
                <b-card-text>
                  <Summary ref="all_summary_cmp" :client_id="client" :claim_id="claim" />
                </b-card-text>
              </b-tab>
              <b-tab title="Project">
                <b-card-text>
                  <Project ref="all_projects_cmp" :claim_id="claim" :client_id="client" />
                </b-card-text>
              </b-tab>
              <b-tab title="Documents" @click="documentTabClick()">
                <b-card-text>
                  <Document ref="all_document_cmp" :claim_id="claim" :client_id="client" />
                </b-card-text>
              </b-tab>

              <b-tab title="View All Claims">
                <b-card-text>
                  <AllClaims ref="all_claims_cmp" :client_id="client" :claim_id="claim" />
                </b-card-text>
              </b-tab>
              <b-tab title="Contact Info">
                <b-card-text>
                  <ContactInfo ref="contact_info_cmp" :claim_id="claim" :client_id="client" />
                </b-card-text>
              </b-tab>

              <b-tab title-item-class="d-none">
                <InternalReview ref="internal_review_cmp" :claim_id="claim" :client_id="client" />
              </b-tab>
              <b-tab title-item-class="d-none">
                <PublishClaim />
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
  </div>
</template>

<script>
import Summary from "@/components/Summary/Summary.vue";
import Project from "@/components/Project/Project.vue";
import Document from "@/components/Document/Document.vue";
import ContactInfo from "@/components/ContactInfo/ContactInfo.vue";
import AllClaims from "@/components/AllClaims/AllClaims.vue";
import InternalReview from "@/components/InternalReview/InternalReview.vue";
import PublishClaim from "@/components/PublishClaim/PublishClaim.vue";
import "vue-select/dist/vue-select.css";
import { mapActions, mapState } from "vuex";
import mixins from "./../../mixins/common.js";
import _ from "lodash";

export default {
  components: {
    Summary,
    Project,
    Document,
    AllClaims,
    InternalReview,
    PublishClaim,
    ContactInfo,
  },

  mixins: [mixins],
  data() {
    return {
      deleteClicked: false,
      userClientOptions: [],
      clientClaimOptions: [],
      claimStatuses: [
        {
          id: 2,
          name: "Assigned",
        },
        {
          id: 3,
          name: "In Progress",
        },
        {
          id: 22,
          name: "No Claim",
        },
        {
          id: 4,
          name: "Accountant",
          disabledByDefault: true
        },
        {
          id: 5,
          name: "Government",
          disabledByDefault: true
        }
      ],
      status: "",
      project: "",
      isLoading: false,
      fullPage: true,
      claimdata: []
    };
  },
  methods: {
    ...mapActions("admin", [
      "getUserClients",
      "getClientsClaims",
      "getClaimProjects",
      "tooglePinStatus",
      "setToInprogessClaim",
      "setToAssignedClaim",
      "setToNoClaim",
      "getClaimRecordById",
      "setToAccountantClaim",
      "setToGovernmentClaim"
    ]),
    claimStatusChanged(value) {
      this.$nextTick(() => {
        const inputElement = this.$refs.claimStatusesDropdown.$el.querySelector('input');
        if (inputElement) {
          inputElement.blur();
        }
      });

      switch (value) {
        case 2:
          this.changeClaimStatusToAssigned();
          break;
        case 3:
          this.changeClaimStatusToWorkInProgress();
          break;
        case 22:
          this.changeClaimStatusToNoClaimDone();
          break;
        case 4:
          this.changeClaimTypeAccountant();
          break;
        case 5:
          this.changeClaimTypeGovernment();
          break;
      }
    },
    internalReviewClass() {
      this.internal_review_class = "fa fa-exclamation-circle";
      if (this.activeClaim) {
        this.internal_review_class = this.internalReviewClassStr(
          this.activeClaim.internalReviewStatus
        );
      }
    },
    refreshClaimSpecificData() {
      let claimParams = {
        claim_id: this.claim,
      };
      if (this.claim) {
        this.getClaimRecordById(claimParams).then((data) => {
          if (data && data.data) {
            this.cs_upadte_str = this.updateByCsStr(
              data.data.csUpdateBy,
              data.data.csUpdatedOn
            );
            this.tr_upadte_str = this.updateByTrStr(
              data.data.trUpdateBy,
              data.data.trUpdatedOn
            );
          } else {
          }
          this.isLoading = false;
        });
      }
    },
    getUserClientsAndClaims() {
      //get query params value and bind
      let claim_id = this.$route.query.claim_id;
      let client_id = this.$route.query.client_id;
      if (!this.client && client_id) {
        this.client = parseInt(client_id);
      }
      if (!this.claim && claim_id) {
        this.claim = parseInt(claim_id);
      }
    },
    documentTabClick() {
      this.$refs.all_document_cmp.refreshClaimDocuments();
    },
    changeClaimDocument() {
      this.$nextTick(() => {
        const inputElement = this.$refs.claimDropdown.$el.querySelector('input');
        if (inputElement) {
          inputElement.blur();
        }
      });

      this.$router.replace({
        name: "claimwizard",
        query: { claim_id: this.claim, client_id: this.client },
      });

      if (this.claimdata) {
        let filtered = this.claimdata.filter((claim) => {
          return claim.id == this.claim;
        });
        if (filtered[0]) {
          this.activeClaim = filtered[0];
          //if (this.activeClaim.claimStatus == 2) {
          //  this.isLoading = true;
          // this.changeClaimStatusToWorkInProgress(filtered[0]);
          //}
          this.$refs.internal_review_cmp.loadPreviousFinancialData();
        }
      }
    },
    onclickPinClaim() {
      let pinParams = {
        claim_id: this.claim,
      };
      this.tooglePinStatus(pinParams).then((data) => {
        if (data.data.errors) {
        } else {
          this.activeClaim.isPinned = !this.activeClaim.isPinned;
        }
      });
    },
    setAcitveTabPane(tb_step) {
      this.tb_step = tb_step;
      if (tb_step == 5) {
        this.$refs.internal_review_cmp.loadPreviousFinancialData();
      }
    },
    filterProjectListByClaim() {
      let projectParams = {
        claim_id: this.claim,
      };
      this.getClaimProjects(projectParams).then((data) => {
        if (data.data.errors) {
        } else {
        }
      });
    },
    filterClaimListByClient() {
      this.$nextTick(() => {
        const inputElement = this.$refs.clientsDropdown.$el.querySelector('input');
        if (inputElement) {
          inputElement.blur();
        }
      });

      this.isLoading = true;
      this.clientClaimOptions = [];
      let clientParams = {
        client_id: this.client,
      };
      if (this.client) {
        this.getClientsClaims(clientParams).then((data) => {
          if (data.data.errors) {
            this.isLoading = false;
          } else {
            if (data.data.length) {
              this.isLoading = false;
              /* loadash filter array from year/month/date */
              let filtered = _.sortBy(data.data, function (dateObj) {
                return new Date(
                  dateObj.fiscalYear +
                  "/" +
                  dateObj.fiscalMonth +
                  "/" +
                  dateObj.fiscalDay
                );
              });
              let sortedClaimArray = filtered; // .reverse();
              this.claimdata = sortedClaimArray;
              this.clientClaimOptions =
                this.filterClientsClaimsOptions(sortedClaimArray);
              if (sortedClaimArray[0]) {
                this.claim = sortedClaimArray[0].id;
                this.activeClaim = sortedClaimArray[0];
                /* set router params */
                this.$router.replace({
                  name: "claimwizard",
                  query: { claim_id: this.claim, client_id: this.client },
                });

                //if (this.activeClaim.claimStatus == 2) {
                // this.changeClaimStatusToWorkInProgress(this.claimdata[0]);
                //}
              } else {
                this.claim = "";
                this.activeClaim = null;
                /* set router params */
                this.$router.replace({
                  name: "claimwizard",
                  query: { client_id: this.client },
                });
              }
              this.$refs.internal_review_cmp.loadPreviousFinancialData();
            } else {
              this.claim = "";
              this.activeClaim = null;
              /* set router params */
              this.$router.replace({
                name: "claimwizard",
                query: { client_id: this.client },
              });
              this.$refs.internal_review_cmp.loadPreviousFinancialData();
              this.isLoading = false;
            }
          }
        });
        let filtered = this.userClientOptions.filter((client) => {
          return client.id == this.client;
        });
        if (filtered[0]) {
          this.client_name = filtered[0].name;
        }
      } else {
        this.claim = "";
        this.isLoading = false;
      }
    },
    setSelectedClientClaim() {
      this.isLoading = true;
      this.clientClaimOptions = [];
      let clientParams = {
        client_id: this.client,
      };
      if (this.client) {
        this.getClientsClaims(clientParams).then((data) => {
          if (data.data.errors) {
            this.isLoading = false;
          } else {
            if (data.data.length) {
              this.isLoading = false;
              /* loadash filter array from year/month/date */
              let filtered = _.sortBy(data.data, function (dateObj) {
                return new Date(
                  dateObj.fiscalYear +
                  "/" +
                  dateObj.fiscalMonth +
                  "/" +
                  dateObj.fiscalDay
                );
              });
              let sortedClaimArray = filtered; //.reverse();
              this.claimdata = sortedClaimArray;
              this.clientClaimOptions =
                this.filterClientsClaimsOptions(sortedClaimArray);

              /* if selected claim exists */
              if (this.claim) {
                /* refresh project component */
                this.$refs.all_projects_cmp.loadProjects();
                /* refresh summary component */
                this.$refs.all_summary_cmp.refreshDocumentList();
                this.$refs.all_summary_cmp.getClientClaimsNotifications();

                let filteredClaim = this.claimdata.filter((claim) => {
                  return claim.id == this.claim;
                });
                if (filteredClaim[0]) {
                  this.activeClaim = filteredClaim[0];

                  /* set last updated string */
                  // this.cs_upadte_str = this.updateByStr(this.activeClaim.csUpdateBy,this.activeClaim.csUpdatedOn);
                  // this.tr_upadte_str = this.updateByStr(this.activeClaim.trUpdateBy,this.activeClaim.trUpdatedOn);

                  // if (this.activeClaim.claimStatus == 2) {
                  //   filteredClaim[0].claimStatus = 3;
                  //   this.changeClaimStatusToWorkInProgress(filteredClaim[0]);
                  // }
                }
              } else {
                if (sortedClaimArray[0]) {
                  this.claim = sortedClaimArray[0].id;

                  this.$router.replace({
                    name: "claimwizard",
                    query: { claim_id: this.claim, client_id: this.client },
                  });

                  this.activeClaim = sortedClaimArray[0];
                  /* set last updated string */
                  // this.cs_upadte_str = this.updateByStr(this.activeClaim.csUpdateBy,this.activeClaim.csUpdatedOn);
                  // this.tr_upadte_str = this.updateByStr(this.activeClaim.trUpdateBy,this.activeClaim.trUpdatedOn);

                  // if (this.activeClaim.claimStatus == 2) {
                  //   this.changeClaimStatusToWorkInProgress(this.claimdata[0]);
                  // }
                }
              }
            } else {
              this.isLoading = false;
              this.claim = "";
            }
          }
        });
        let filtered = this.userClientOptions.filter((client) => {
          return client.id == this.client;
        });
        if (filtered[0]) {
          this.client_name = filtered[0].name;
        }
      } else {
        this.claim = "";
        this.isLoading = false;
      }
    },
    refreshClaimDropDownOptions() {
      this.clientClaimOptions = [];
      if (this.client) {
        let clientParams = {
          client_id: this.client,
        };
        this.getClientsClaims(clientParams).then((data) => {
          if (data.data.errors) {
          } else {
            if (data.data.length) {
              /* loadash filter array from year/month/date */
              let filtered = _.sortBy(data.data, function (dateObj) {
                return new Date(
                  dateObj.fiscalYear +
                  "/" +
                  dateObj.fiscalMonth +
                  "/" +
                  dateObj.fiscalDay
                );
              });
              let sortedClaimArray = filtered; //.reverse();
              this.clientClaimOptions =
                this.filterClientsClaimsOptions(sortedClaimArray);
            }
          }
        });
      }
    },
    changeClaimStatusToWorkInProgress() {
      if (this.checkIfClaimHasPermission(this.activeClaim)) {
        this.isLoading = true;
        this.setToInprogessClaim(this.activeClaim).then((data) => {
          if (!data.data.errors) {
            this.activeClaim.claimStatus = 3;
            this.refreshClaimSpecificData();
          }
          this.isLoading = false;
        });
      }
    },
    changeClaimTypeGovernment() {
      if (this.checkIfClaimHasPermission(this.activeClaim)) {
        this.isLoading = true;
        this.setToGovernmentClaim(this.activeClaim).then((data) => {
          if (!data.data.errors) {
            this.activeClaim.claimStatus = 5;
            this.refreshClaimSpecificData();
          }
          this.isLoading = false;
        });
      }
    },
    changeClaimTypeAccountant() {
      if (this.checkIfClaimHasPermission(this.activeClaim)) {
        this.isLoading = true;
        this.setToAccountantClaim(this.activeClaim).then((data) => {
          if (!data.data.errors) {
            this.activeClaim.claimStatus = 4;
            this.refreshClaimSpecificData();
          }
          this.isLoading = false;
        });
      }
    },
    changeClaimStatusToAssigned() {
      if (this.checkIfClaimHasPermission(this.activeClaim)) {
        this.isLoading = true;
        this.setToAssignedClaim(this.activeClaim).then((data) => {
          if (!data.data.errors) {
            this.activeClaim.claimStatus = 2;
            this.refreshClaimSpecificData();
          }
          this.isLoading = false;
        });
      }
    },
    changeClaimStatusToNoClaimDone(claimData) {
      if (this.checkIfClaimHasPermission(this.activeClaim)) {
        this.isLoading = true;
        this.setToNoClaim(this.activeClaim).then((data) => {
          if (!data.data.errors) {
            this.activeClaim.claimStatus = 22;
            this.refreshClaimSpecificData();
          }
          this.isLoading = false;
        });
      }
    },
    filterClientsClaimsOptions(options) {
      let arr = [];
      options.forEach((value, index) => {
        let obj = {
          label: this.claimDropDownLable(value),
          id: value.id,
        };
        arr.push(obj);
      });
      return arr;
    },
    getMonthNameFormValue(val) {
      const monthNames = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return monthNames[val - 1];
    },
    ammendString(type) {
      let amendStr = "";
      if (type == 1) {
        amendStr = "Amended";
      } else if (type == 2) {
        amendStr = "Non-Amended";
      }
      return amendStr;
    },
  },
  computed: {
    ...mapState("user", ["user_id", "is_admin"]),
    disablePublishTabCondition() {
      let disableCheck = false;
      if (this.activeClaim) {
        if (
          (this.activeClaim.internalReviewStatus != 4 &&
            this.activeClaim.internalReviewStatus != 5) ||
          !this.activeClaim.claimType
        ) {
          disableCheck = true;
        }
      } else {
        disableCheck = true;
      }
      return disableCheck;
    },
    internalReviewDiableCheck() {
      let disableCheck = true;
      if (this.activeClaim) {
        if (this.activeClaim.claimStatus == 3) {
          disableCheck = false;
        } else {
          disableCheck = true;
        }
      } else {
        disableCheck = true;
      }
      return disableCheck;
    },
    dynamicClass() {
      if (this.activeClaim && this.activeClaim.isPinned) {
        return "green";
      } else {
        return "white";
      }
    },
    tr_upadte_str: {
      get() {
        return this.$store.state.admin.tr_upadte_str;
      },
      set(val) {
        this.$store.state.admin.tr_upadte_str = val;
      },
    },
    internal_review_class: {
      get() {
        return this.$store.state.internal_review_class;
      },
      set(val) {
        this.$store.state.internal_review_class = val;
      },
    },
    cs_upadte_str: {
      get() {
        return this.$store.state.admin.cs_upadte_str;
      },
      set(val) {
        this.$store.state.admin.cs_upadte_str = val;
      },
    },
    client: {
      get() {
        return this.$store.state.client;
      },
      set(val) {
        this.$store.state.client = val;
      },
    },
    tb_step: {
      get() {
        return this.$store.state.tb_step;
      },
      set(val) {
        this.$store.state.tb_step = val;
      },
    },
    claim: {
      get() {
        return this.$store.state.claim;
      },
      set(val) {
        this.$store.state.claim = val;
      },
    },
    client_name: {
      get() {
        return this.$store.state.client_name;
      },
      set(val) {
        this.$store.state.client_name = val;
      },
    },
    // claimStatus() {
    //   if (this.activeClaim) {
    //     return this.claimStatusIdToString(this.activeClaim.claimStatus);
    //   } else {
    //     return "";
    //   }
    // },
    claimStatus: {
      get() {
        if (this.activeClaim) {
          return this.claimStatusIdToString(this.activeClaim.claimStatus);
        } else {
          return "";
        }
      },
      set(val) {
        this.claimStatusIdToString(val);
      }
    },
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
  },
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
    const userdata = {
      user_id: this.user_id,
    };
    this.getUserClients(userdata).then((data) => {
      if (data.data.errors) {
      } else {
        this.userClientOptions = data.data;
        this.getUserClientsAndClaims();
        this.setSelectedClientClaim();
      }
    });
  },
  watch: {
    tb_step: function (newVal, oldVal) {
      if (this.tb_step != this.$route.query.tb_step) {
        this.$router.replace({
          name: "claimwizard",
          query: {
            claim_id: this.claim,
            client_id: this.client,
            tb_step: this.tb_step,
          },
        });
      }
    },
    "activeClaim.claimType": function (newVal, oldVal) {
      if (this.activeClaim) {
        this.refreshClaimDropDownOptions();
      }
    },
    activeClaim: function (newVal, oldVal) {
      if (this.activeClaim) {
        this.internalReviewClass();
      }
    },
  },
  created() {
    if (this.$route.query.tb_step) {
      this.tb_step = parseInt(this.$route.query.tb_step);
    }
  },
};
</script>

<style scoped>
.special-buttons {
  z-index: 1000;
  position: relative;
}

.btn-design {
  padding: 0.75rem 1rem;
  color: #8b2326;
  font-weight: 500;
  font-size: 0.875rem;
  -webkit-box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  box-shadow: 0 4px 6px rgb(50 50 93 / 11%), 0 1px 3px rgb(0 0 0 / 8%);
  background-color: #fff;
  -webkit-transition: all 0.15s ease;
  transition: all 0.15s ease;
  border-color: #f8f8f8;
}
</style>

<style>
.red {
  background-color: #8b2326;
  color: #ffffff;
}

.green {
  background-color: green;
  border-color: transparent !important;
  color: #ffffff;
}
</style>
